module.exports = __webpack_public_path__ + "img/image8.512cfefe.jpg";